import React from 'react';
import PropTypes from 'prop-types';
import {
  Card, CardBody, Col, Row,
} from 'reactstrap';
import ReactTableBase from 'src/shared/components/table/ReactTableBase';
import { useTranslation } from 'react-i18next';

const MobileDeviceCancellationLogDetails = ({ reactTableData, isNoRecordFound }) => {
  const { t } = useTranslation('common');
  const tableConfig = {
    isEditable: false,
    isSortable: true,
    isResizable: true,
    withPagination: true,
    withSearchEngine: true,
    manualPageSize: [10, 50, 100, 1000],
    placeholder: 'Search...',
  };

  const tableRowsData = reactTableData?.tableRowsData || [];
  const tableHeaderData = reactTableData?.tableHeaderData || [];

  return (
    <Col md={12} lg={12}>
      <Card>
        <CardBody>
          {!isNoRecordFound && tableRowsData.length > 0 &&
            <ReactTableBase
              name="Device License Log"
              key={'searchable'}
              columns={tableHeaderData}
              data={tableRowsData}
              tableConfig={tableConfig}
            />
          }
          {isNoRecordFound && <h3 className="page-title">No Record Found</h3>}
        </CardBody>
      </Card>
    </Col>
  );
};

MobileDeviceCancellationLogDetails.propTypes = {
  reactTableData: PropTypes.shape({
    tableHeaderData: PropTypes.arrayOf(PropTypes.shape({
      key: PropTypes.string,
      name: PropTypes.string,
    })),
    tableRowsData: PropTypes.arrayOf(PropTypes.shape()),
  }),
  isNoRecordFound: PropTypes.bool,
};

MobileDeviceCancellationLogDetails.defaultProps = {
  reactTableData: null,
  isNoRecordFound: false,
};

export default MobileDeviceCancellationLogDetails;
